// extracted by mini-css-extract-plugin
export default {"pill":"radio_pill__UraDa","selected":"radio_selected__-OLd1","input":"radio_input__ngE6a"};